import Box from '@ilg-totallymoney/ui/components/Box'
import Flex from '@ilg-totallymoney/ui/components/Flex'
import Text from '@ilg-totallymoney/ui/components/Text'
import Icon from '@ilg-totallymoney/ui/icons/Icon'
import theme from '@ilg-totallymoney/ui/theme'

const IconTextLabel = ({
    label,
    value,
    isGuaranteed,
    isLast = false,
}: {
    isGuaranteed: boolean
    isLast?: boolean
    label: string
    value: string
}) => (
    <Flex
        justifyContent="space-between"
        p="space10"
        borderBottom={isLast ? 'none' : `1px solid ${theme.grey10}`}
        gridColumnGap="space20"
        width="100%"
    >
        <Flex gridColumnGap="space05" alignItems="center" flexWrap="wrap">
            {isGuaranteed && (
                <Box mt="space05">
                    <Icon
                        icon="guaranteed"
                        size={16}
                        color={theme['eligibilityLevel0-100']}
                    />
                </Box>
            )}
            {isGuaranteed && (
                <Text variant="80" weight="bold">
                    Guaranteed{' '}
                </Text>
            )}
            <Text variant="80">{label}</Text>
        </Flex>
        <Text variant="80" weight="bold" style={{ whiteSpace: 'nowrap' }}>
            {value}
        </Text>
    </Flex>
)

export default IconTextLabel
